import React, { FC, Suspense } from 'react';
import { AnalyticsSenderProvider } from '@funtech-int/yango-shared';
import { ErrorBoundary, useRouteMatch } from '@funtech-int/rival-react';

import { MovieCardContent } from '../MovieCard/MovieCard';
import { MovieCardSkeleton } from '../MovieCardSkeleton/MovieCardSkeleton';

import styles from './MovieCardModal.module.css';
import { MovieCardModalError } from './_MovieCardModalError';

export interface MovieCardModalContentProps {
    contentId: string;
}

export const MovieCardModal: FC<MovieCardModalContentProps> = ({ contentId }) => {
    const location = useRouteMatch();

    return (
        <ErrorBoundary fallback={MovieCardModalError}>
            <div className={styles.root}>
                <AnalyticsSenderProvider>
                    <Suspense fallback={<MovieCardSkeleton />}>
                        <MovieCardContent
                            key={contentId}
                            contentId={contentId}
                            location={location}
                        />
                    </Suspense>
                </AnalyticsSenderProvider>
            </div>
        </ErrorBoundary>
    );
};
